import React from 'react';
import { mergeStyles } from '@cian/utils';
import { Outside } from '@cian/ui-kit';

import * as stylesCommon from '../FiltersCommon/FiltersCommon.css';
import styles from './styles.css';
import { Checkbox } from '../Checkbox';
import { IFilterMultiChooseProps } from './types';
import { useMultiChooseController } from './utils/useMultiChooseController';

export const FilterMultiChoose = <T extends string | number>(props: IFilterMultiChooseProps<T>) => {
  const { items, className } = props;
  const [isActive, setIsActive] = React.useState(false);
  const { selectedItems, handleSelectItem, selectedItemsUiLabel } = useMultiChooseController(props);

  const itemsArray = React.useMemo(() => Array.from(items), [items]);

  return (
    <Outside onOutside={() => setIsActive(false)}>
      <div {...mergeStyles(stylesCommon['container'], className)} data-mark="FilterMultiChoose">
        <button
          {...mergeStyles(
            stylesCommon['button'],
            isActive && stylesCommon['button--active'],
            selectedItems.size === 0 && stylesCommon['button--empty'],
          )}
          onClick={() => setIsActive(!isActive)}
        >
          {selectedItemsUiLabel}
        </button>
        {isActive && (
          <div className={styles['dropdown']}>
            <ul className={styles['list']}>
              {itemsArray.map(([key, label]) => (
                <li key={`item_${key}`}>
                  <div className={styles['dropdown_item']}>
                    <Checkbox label={label} value={key} checked={selectedItems.has(key)} onChange={handleSelectItem} />
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </Outside>
  );
};

FilterMultiChoose.displayName = 'FilterMultiChoose';
